import { SvgIcon, SvgIconProps } from "@mui/joy";
import { forwardRef } from "react";

const FlashedCircle = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="16" rx="8" fill="#FFE70D" />
        <path
          d="M6.88946 13.025L7.45166 9.12498H5.03906L8.58926 2.97498H9.12686L8.57666 6.86238H10.9767L7.42706 13.025H6.88946Z"
          fill="#010024"
        />
      </svg>
    </SvgIcon>
  );
});

FlashedCircle.displayName = "Warning";

export default FlashedCircle;
